import { render, staticRenderFns } from "./ekko.faq.vue?vue&type=template&id=1a815e8c&scoped=true&"
import script from "./ekko.faq.vue?vue&type=script&lang=ts&"
export * from "./ekko.faq.vue?vue&type=script&lang=ts&"
import style0 from "./ekko.faq.vue?vue&type=style&index=0&id=1a815e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a815e8c",
  null
  
)

export default component.exports